
import firebase from './FirebaseConfig.js'

/*class AnalyticsHelper {

  function genEvent (event, type, detail) {
    firebase.analytics().logEvent(event,
                                    {
                                      content_type: type,
                                      detail: detail
                                    }
                                  )
  }

}

export default AnalyticsHelper*/

class AnalyticsHelper {
  constructor () {
    if (!AnalyticsHelper.instance) {
      AnalyticsHelper.instance = this
    }
    // Initialize object
    return AnalyticsHelper.instance
  }

  // Properties & Methods
  EVENT_SELECT = "select_content"
    SELECT_LIST_ROW = "list_row"
    SELECT_PILL = "pill"
  EVENT_SEARCH = "search_content"
    SEARCH_SEARCH_PAGE = "search_page"
    SEARCH_LANDING = "landing_page"

  // event is one of the constants above
  // type is
  genEvent (event, type, detail) {
    firebase.analytics().logEvent(event,
                                    {
                                      content_type: type,
                                      detail: detail
                                    }
                                  )
  }

}

const instance = new AnalyticsHelper()
Object.freeze(instance)

export default instance



// WEBPACK FOOTER //
// src/AnalyticsHelper.js